/* global $:false */

import 'jquery-lazyload/jquery.lazyload.js'

import AbsenteeBidForm from 'src/public/absentee_bid_form.js'
import AccountIdentity from 'src/public/my_pages/account_identity.js'
import AlertBoxes from 'src/public/alert_boxes.js'
import Anniversary from 'src/public/anniversary.js'
import AppNavigationBridge from 'src/public/app_navigation_bridge.js'
import BeneficialOwner from 'src/public/my_pages/beneficial_owner.js'
import BeneficialOwnerInserter from 'src/public/my_pages/beneficial_owner_inserter.js'
import BidHistory from 'src/public/live/bid_history.js'
import Bidder from 'src/public/live/bidder.js'
import CarouselSlideshow from 'src/public/carousel_slideshow.js'
import ClickRequiresLogin from 'src/public/click_requires_login.js'
import CommonLotShowAccordionTab from 'src/public/common_lot_show_accordion_tab.js'
import CommonLotShowGalleryImage from 'src/public/common_lot_show_gallery_image.js'
import CommonLotShowGalleryPinch from 'src/public/common_lot_show_gallery_pinch.js'
import CommonLotShowGallerySwipeHint from 'src/public/common_lot_show_gallery_swipe_hint.js'
import CommonLotShowGalleryThumbnail from 'src/public/common_lot_show_gallery_thumbnail.js'
import CommonLotShowSocial from 'src/public/common_lot_show_social.js'
import ConnectionStateMonitor from 'src/shared/connection_state_monitor.js'
import ContactInfos from 'src/public/contact_infos.js'
import ContentBlockSlugs from 'src/public/content_block_slugs.js'
import CookieBanner from 'src/public/cookie_banner.js'
import CountdownJs from 'src/public/countdownjs.js'
import DirectUpload from 'src/public/direct_upload.js'
import EnvironmentBar from 'src/environment_bar.js'
import FAQ from 'src/public/faq.js'
import FacebookShare from 'src/public/facebook_share.js'
import Favorites from 'src/public/favorites.js'
import FilterList from 'src/public/filter_list.js'
import HomeOfficeTrigger from 'src/public/home_office_trigger.js'
import HtmlPush from 'src/shared/html_push.js'
import IeAspectRatioImage from 'src/public/ie_aspect_ratio_image.js'
import LiveBanner from 'src/public/live/live_banner.js'
import LoginDialog from 'src/public/login_dialog.js'
import LotThumbnail from 'src/public/lot_thumbnails.js'
import LotsBannerBlock from 'src/public/lots_banner_block.js'
import MarketLotIndexLot from 'src/public/market_lot_index_lot.js'
import MarketLotShowBidExplanation from 'src/public/market_lot_show_bid_explanation.js'
import MarketLotShowBidHistoryExpansion from 'src/public/market_lot_show_bid_history_expansion.js'
import MarketLotShowSidebar from 'src/public/market_lot_show_sidebar.js'
import MegaMenu from 'src/public/mega_menu.js'
import PaymentPending from 'src/public/payment_pending.js'
import PopulateDataLayer from 'src/public/populate_data_layer.js'
import Popup from 'src/public/popup.js'
import PrintForm from 'src/public/print_form.js'
import ReadMore from 'src/public/read_more.js'
import RegistrationForm from 'src/public/registration_form.js'
import SearchObservers from 'src/public/search_observers.js'
import ShippingQuoteForm from 'src/public/shipping_quote_form.js'
import ShoppingCartDropdown from 'src/public/shopping_cart_dropdown.js'
import SidebarContentBlockSlugs from 'src/public/sidebar_content_block_slugs.js'
import SidemenuFolder from 'src/public/sidemenu_folder.js'
import Slidebar from 'src/public/slidebar.js'
import SystembolagetAgeForm from 'src/public/systembolaget_age_form.js'
import Toggler from 'src/public/toggler.js'
import TopbarContentBlockSlugs from 'src/public/topbar_content_block_slugs.js'
import Valuation from 'src/public/valuation.js'
import ValuationRequestCategory from 'src/public/my_pages/valuation_request_category.js'
import WatchingLiveChanges from 'src/public/live/watching_live_changes.js'

export default class Site {
  static init () {
    AbsenteeBidForm.init()
    AccountIdentity.init()
    AlertBoxes.init()
    Anniversary.init()
    AppNavigationBridge.init()
    BeneficialOwner.init()
    BeneficialOwnerInserter.init()
    BidHistory.init()
    Bidder.init()
    CarouselSlideshow.init()
    ClickRequiresLogin.init()
    CommonLotShowAccordionTab.init()
    CommonLotShowGalleryImage.init()
    CommonLotShowGalleryPinch.init()
    CommonLotShowGallerySwipeHint.init()
    CommonLotShowGalleryThumbnail.init()
    CommonLotShowSocial.init()
    ConnectionStateMonitor.init()
    ContactInfos.init()
    ContentBlockSlugs.init()
    CookieBanner.init()
    CountdownJs.init()
    DirectUpload.init()
    EnvironmentBar.init()
    FAQ.init()
    FacebookShare.init()
    Favorites.init()
    FilterList.init()
    HomeOfficeTrigger.init()
    HtmlPush.init('html-push-' + window.gon.locale + '-')
    IeAspectRatioImage.init()
    LiveBanner.bannerOrFullPage()
    LoginDialog.init()
    LotThumbnail.init()
    LotsBannerBlock.init()
    MarketLotIndexLot.init()
    MarketLotShowBidExplanation.init()
    MarketLotShowBidHistoryExpansion.init()
    MarketLotShowSidebar.init()
    MegaMenu.init()
    PaymentPending.init()
    PopulateDataLayer.init()
    Popup.init()
    PrintForm.init()
    ReadMore.init()
    RegistrationForm.init()
    SearchObservers.init()
    ShippingQuoteForm.init()
    ShoppingCartDropdown.init()
    SidebarContentBlockSlugs.init()
    SidemenuFolder.init()
    Slidebar.init()
    SystembolagetAgeForm.init()
    Toggler.init()
    TopbarContentBlockSlugs.init()
    Valuation.init()
    ValuationRequestCategory.init()
    WatchingLiveChanges.init()

    $('img').lazyload({ threshold: 200, failure_limit: 15 })
  }
}
